<template>
  <v-container class="pa-0">
    <!--app-view-toolbar-->
    <app-view-toolbar :title="headline" :showBackButton="true" :isEdit="false" :buttons="toolbarButtons" @onButton="onToolbarButton"></app-view-toolbar>
    <template v-if="viewDataIsLoaded">
      <!--(assigment) owner is viewing, evaluate signingStatus-->
      <v-row
        v-if="viewData.assignmentData.isAssigned"
      >
        <!---assignment has been assigned-->
        <v-col>
          <v-card
            class="mx-auto"
            color="accent"
            dark="dark"
          >
            <div class="pa-4">
              <div class="text-body">
                Jobbet har tilldelats: 
                <span
                  @click="showAssignedDriver()"
                  class="xLink"
                >{{ viewData.assignmentData.assignedDriverData.name }}</span>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="ph-12 pb-6">
        <v-col>
          <!--assignment data-card-->
          <app-data-card :title="viewData.assignmentData.name" :data_ar="viewData.presentationData.assignmentData_ar" mode="view" :dark="false" :color="'blue-grey lighten-5'" class="mb-6"></app-data-card>
          <!--google-map-->
          <app-google-map
            :markers="markers"
            mode="view"
            :data="viewData.mapData"

          ></app-google-map>
        </v-col>
      </v-row>
    </template>
    <!--snack-bar-->
    <app-snack-bar></app-snack-bar>
  </v-container>
</template>

<script>
import axios from 'axios'
import SnackBar from '../components/SnackBar'
import ViewToolbar from '../components/ViewToolbar'
import GoogleMap from '../components/GoogleMap'
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'
import { googleMapMixin } from '../mixins/googleMap'
import { snackBarBus } from '../main'
import { mapGetters } from 'vuex'
import DataCard from '../components/DataCard'

export default {
  name: 'AdminAssignment',
  components: {
    'app-snack-bar': SnackBar,
    'app-google-map': GoogleMap,
    'app-data-card': DataCard,
    'app-view-toolbar': ViewToolbar
  },
  mixins: [generalMixin, urlMixin, googleMapMixin],
  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      viewData: {},
      headline: 'Jobb',
      viewDataIsLoaded: false,
      markers: [
        {
          label: 'startPos',
          position: null,
          name: 'Start',
          icon: {
            url: require('../assets/markers/start.png'),
            scaledSize: {width: 64, height: 64},
            labelOrigin: {x: 16, y: -10}
          }
        },
        {
          label: 'endPos',
          position: null,
          name: 'Mål',
          icon: {
            url: require('../assets/markers/goal.png'),
            scaledSize: {width: 64, height: 64},
            labelOrigin: {x: 16, y: -10}
          }
        }
      ],
    }
  },
  computed: {
    ...mapGetters(['access_token', 'loggedInData']),
    toolbarButtons() {
      /* TODO
      if (this.viewDataIsLoaded && this.viewData.whoIsViewing == 'owner' && this.viewData.signingStatus == 'hasNoDrivers') {
        return [
          {
            label: 'edit',
            icon: 'pencil',
            title: 'Redigera jobb'
          }
        ]
      }
      */
      return []
    }
  },
  watch: {
    viewDataIsLoaded(value) {
      if (value) {
        //possibly update positions in markerData
        let label, position
        for (let marker of this.markers) {
          label = marker.label
          position = this.viewData.mapData[label]
          if (position.lat !== 0 && position.lng !== 0) {
            //label has real position, update marker in markers (that is invoked in google-map)
            marker.position = position
          }
        }
      }
    }
  },
  methods: {
    onViewData(viewData) {
      this.viewData = viewData
      this.viewDataIsLoaded = true
    },
    onToolbarButton(button) {
      switch (button.label) {
        case 'edit':
          this.editAssignment()
          break
      }
    },
    editAssignment() {
      this.$router.push({ name: 'assignment-edit', params: { id: this.viewData.assignmentData.id } })
    }
  },
  created() {
    //get view data
    let config = {
      headers: {
        'Authorization': this.access_token
      }
    }
    let url = this.url_composeApiUrl('/admin/assignment/' + this.uuid)
    console.log('get', url)
    axios.get(url, config)
      .then(response => {
        console.log('response', response)
        if (response.data.success) {
          //success
          this.onViewData(response.data.returnData.viewData)
        } else if (this.onNonSuccessApiCall(response.data.returnData)) {
          snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
        }
      })
      .catch(error => {
        snackBarBus.$emit('message', error.toString())
      })
  }
}
</script>
<style>
</style>